import React, { useEffect, useState } from "react";
import {
  useDrillViewData,
  useFieldEditorData,
} from "../hooks/useFieldEditorShared.tsx";

export default function FieldEditorModeSelect() {
  // Get data from context hooks
  const { engine } = useDrillViewData();
  const { fieldEditorData, setFieldEditorData } = useFieldEditorData();

  // These could come from context too if needed
  const collaboratorPermission = "editor"; // default or from user context
  const analytics = null; // or from analytics context
  const [numSelectedPerformers, setNumSelectedPerformers] = useState(0);

  useEffect(() => {
    if (!engine) return;

    const updateSelectedPerformers = () => {
      setNumSelectedPerformers(engine.selectedPerformers.length);
    };

    engine.on("performers-selected", updateSelectedPerformers);
    updateSelectedPerformers();

    return () => {
      engine.removeOn("performers-selected", updateSelectedPerformers);
    };
  }, [engine]);

  return (
    <div className="w-14 bg-gray-50 border-r flex flex-col items-center py-4 space-y-4">
      {collaboratorPermission !== "viewer" && (
        <>
          {" "}
          <button
            onClick={() =>
              setFieldEditorData({ ...fieldEditorData, editMode: "PAN" })
            }
            className={`p-2.5 rounded-md transition-colors ${
              fieldEditorData.editMode === "PAN"
                ? "bg-blue-100 text-blue-600"
                : "text-gray-500 hover:bg-gray-100"
            }`}
            title="Pan (1)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 8L22 12L18 16"></path>
              <path d="M2 12H22"></path>
              <path d="M6 8L2 12L6 16"></path>
            </svg>
          </button>
          <button
            type="button"
            data-tour="select-mode"
            onClick={() =>
              setFieldEditorData({
                ...fieldEditorData,
                editMode: "SELECT_AND_MOVE",
              })
            }
            className={`p-2.5 rounded-md transition-colors ${
              fieldEditorData.editMode === "SELECT_AND_MOVE"
                ? "bg-blue-100 text-blue-600"
                : "text-gray-500 hover:bg-gray-100"
            }`}
            title="Select (2)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 12L20 12"></path>
              <path d="M12 4L12 20"></path>
            </svg>
          </button>
          <button
            onClick={() =>
              setFieldEditorData({
                ...fieldEditorData,
                editMode: "PAINT_PERFORMERS",
              })
            }
            disabled={numSelectedPerformers === 0}
            className={`p-2.5 rounded-md transition-colors
${
  numSelectedPerformers === 0
    ? "bg-gray-100 text-gray-300  cursor-normal"
    : fieldEditorData.editMode === "PAINT_PERFORMERS"
    ? "bg-blue-100 text-blue-600"
    : "text-gray-500 hover:bg-gray-100"
}`}
            title="Paint (3)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 19l7-7 3 3-7 7-3-3z"></path>
              <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path>
              <path d="M2 2l7.586 7.586"></path>
              <circle cx="11" cy="11" r="2"></circle>
            </svg>
          </button>
        </>
      )}
      <button
        onClick={() => {
          setFieldEditorData({ ...fieldEditorData, editMode: "comment" });
        }}
        className={`p-2.5 rounded-md transition-colors ${
          fieldEditorData.editMode === "comment"
            ? "bg-blue-100 text-blue-600"
            : "text-gray-500 hover:bg-gray-100"
        }`}
        title="Comment (4)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
      </button>
      <div className="relative inline-block">
        <button
          onClick={() => {
            setFieldEditorData({ ...fieldEditorData, editMode: "analyze" });
          }}
          className={`p-2.5 rounded-md transition-colors ${
            fieldEditorData.editMode === "analyze"
              ? "bg-blue-100 text-blue-600"
              : "text-gray-500 hover:bg-gray-100"
          }`}
          title="Analyze (5)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6"
          >
            <path
              fillRule="evenodd"
              d="M2.25 2.25a.75.75 0 0 0 0 1.5H3v10.5a3 3 0 0 0 3 3h1.21l-1.172 3.513a.75.75 0 0 0 1.424.474l.329-.987h8.418l.33.987a.75.75 0 0 0 1.422-.474l-1.17-3.513H18a3 3 0 0 0 3-3V3.75h.75a.75.75 0 0 0 0-1.5H2.25Zm6.04 16.5.5-1.5h6.42l.5 1.5H8.29Zm7.46-12a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Zm-3 2.25a.75.75 0 0 0-1.5 0v3.75a.75.75 0 0 0 1.5 0V9Zm-3 2.25a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        {/* {showTooLargeStepSizeNotification.length > 0 && (
                    <div
                        className={`absolute bottom-auto left-auto right-0 top-0 z-10 inline-block translate-y-6 -translate-x-1 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 rounded-full bg-red-600 p-1 transition-all duration-[2s] ${showTooLargeStepSizeNotification.length > 1 ? "opacity-100" : "opacity-0"}`}>

                    </div>
                )} */}

        {/* <NewBadge /> */}
      </div>
    </div>
  );
}
